import createSvgIcon from '../Utils/CreateSvgIcon';

export const Bluetooth = createSvgIcon(
  <path d="m6 16 10-8-5-4v16l5-4L6 9" fill="transparent" stroke="currentColor" strokeWidth="2" />,
  'Bluetooth',
);
